"use strict";

var _classCallCheck = require("/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClientInfo = void 0;

var platform = require("platform");

var ClientInfo = function ClientInfo(version) {
  _classCallCheck(this, ClientInfo);

  this.sdk = 'js';
  this.sdkVer = version;
  this.os = platform.os.family;
  this.osVer = platform.os.version;
  this.pl = platform.name;
  this.plVer = platform.version;
};

exports.ClientInfo = ClientInfo;
exports.default = ClientInfo;